if (!customElements.get('influencer-dialog')) {
  customElements.define('influencer-dialog', class InfluencerDialog extends ModalDialog {
    constructor() {
      super();

      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'INFLUENCER-DIALOG')
          this.hide();
      });
    }

    show(opener) {
      this.openedBy = opener;
      document.body.classList.add('overflow-hidden');
      document.documentElement.classList.add('overflow-hidden');
      this.setAttribute('open', '');
      trapFocus(this, this.querySelector('[role="dialog"]'));
      this.populateModal(opener);
    }

    populateModal(opener) {
      const blockId = opener.dataset.blockId;
      const blockImg = document.querySelector(`img[data-block-img="${blockId}"]`);
      const blockImgClone = blockImg.cloneNode(true);
      const modalContent = document.querySelector('[data-masonry-modal-content]');
      modalContent.querySelector('[data-masonry-modal-image]').innerHTML = '';
      modalContent.querySelector('[data-masonry-modal-image]').appendChild(blockImgClone);
      modalContent.querySelector('[data-masonry-modal-button]').innerHTML = opener.dataset.shopButtonText;
      modalContent.querySelector('[data-masonry-modal-button]').setAttribute('href', opener.dataset.shopButtonLink);
      modalContent.querySelector('[data-masonry-modal-handle]').innerHTML = opener.dataset.influencerHandle;
    }
  });
}